export class Client {
  public id: string;
  public title: string;
  public fullName: string;
  public address: string;
}
